export { ModificationResidueItem } from './ModificationResidueItem.component';
